import { RegionalFactors, MarketData } from '../types';

// US States and their typical tax characteristics - Enhanced with income tax rates
export const US_STATES = [
  { code: 'AL', name: 'Alabama', taxRate: 0.04 },
  { code: 'AK', name: 'Alaska', taxRate: 0.00 },
  { code: 'AZ', name: 'Arizona', taxRate: 0.03 },
  { code: 'AR', name: 'Arkansas', taxRate: 0.06 },
  { code: 'CA', name: 'California', taxRate: 0.08 },
  { code: 'CO', name: 'Colorado', taxRate: 0.05 },
  { code: 'CT', name: 'Connecticut', taxRate: 0.06 },
  { code: 'DE', name: 'Delaware', taxRate: 0.06 },
  { code: 'FL', name: 'Florida', taxRate: 0.00 },
  { code: 'GA', name: 'Georgia', taxRate: 0.06 },
  { code: 'HI', name: 'Hawaii', taxRate: 0.08 },
  { code: 'ID', name: 'Idaho', taxRate: 0.06 },
  { code: 'IL', name: 'Illinois', taxRate: 0.05 },
  { code: 'IN', name: 'Indiana', taxRate: 0.03 },
  { code: 'IA', name: 'Iowa', taxRate: 0.06 },
  { code: 'KS', name: 'Kansas', taxRate: 0.05 },
  { code: 'KY', name: 'Kentucky', taxRate: 0.05 },
  { code: 'LA', name: 'Louisiana', taxRate: 0.04 },
  { code: 'ME', name: 'Maine', taxRate: 0.07 },
  { code: 'MD', name: 'Maryland', taxRate: 0.05 },
  { code: 'MA', name: 'Massachusetts', taxRate: 0.05 },
  { code: 'MI', name: 'Michigan', taxRate: 0.04 },
  { code: 'MN', name: 'Minnesota', taxRate: 0.07 },
  { code: 'MS', name: 'Mississippi', taxRate: 0.05 },
  { code: 'MO', name: 'Missouri', taxRate: 0.05 },
  { code: 'MT', name: 'Montana', taxRate: 0.06 },
  { code: 'NE', name: 'Nebraska', taxRate: 0.06 },
  { code: 'NV', name: 'Nevada', taxRate: 0.00 },
  { code: 'NH', name: 'New Hampshire', taxRate: 0.00 },
  { code: 'NJ', name: 'New Jersey', taxRate: 0.08 },
  { code: 'NM', name: 'New Mexico', taxRate: 0.05 },
  { code: 'NY', name: 'New York', taxRate: 0.07 },
  { code: 'NC', name: 'North Carolina', taxRate: 0.05 },
  { code: 'ND', name: 'North Dakota', taxRate: 0.03 },
  { code: 'OH', name: 'Ohio', taxRate: 0.04 },
  { code: 'OK', name: 'Oklahoma', taxRate: 0.05 },
  { code: 'OR', name: 'Oregon', taxRate: 0.09 },
  { code: 'PA', name: 'Pennsylvania', taxRate: 0.03 },
  { code: 'RI', name: 'Rhode Island', taxRate: 0.06 },
  { code: 'SC', name: 'South Carolina', taxRate: 0.07 },
  { code: 'SD', name: 'South Dakota', taxRate: 0.00 },
  { code: 'TN', name: 'Tennessee', taxRate: 0.00, incomeTaxRate: 0.00 },
  { code: 'TX', name: 'Texas', taxRate: 0.00, incomeTaxRate: 0.00 },
  { code: 'UT', name: 'Utah', taxRate: 0.05 },
  { code: 'VT', name: 'Vermont', taxRate: 0.06 },
  { code: 'VA', name: 'Virginia', taxRate: 0.06 },
  { code: 'WA', name: 'Washington', taxRate: 0.00 },
  { code: 'WV', name: 'West Virginia', taxRate: 0.06 },
  { code: 'WI', name: 'Wisconsin', taxRate: 0.06 },
  { code: 'WY', name: 'Wyoming', taxRate: 0.00 }
];

// Regional cost adjustments by area type - Enhanced for specification
export const REGIONAL_COST_ADJUSTMENTS = {
  urban: {
    costOfLivingMultiplier: 1.3,
    housingMultiplier: 1.5,
    transportationSavings: 0.15,
    adjustmentFactor: 1.25 // Higher cost areas
  },
  suburban: {
    costOfLivingMultiplier: 1.1,
    housingMultiplier: 1.2,
    transportationSavings: 0.05,
    adjustmentFactor: 1.0 // Baseline
  },
  rural: {
    costOfLivingMultiplier: 0.9,
    housingMultiplier: 0.8,
    transportationSavings: 0.0,
    adjustmentFactor: 0.85 // Lower cost areas
  }
};

// Regional adjustment factors by state (for auto-population)
export const STATE_ADJUSTMENT_FACTORS: Record<string, number> = {
  'CA': 1.35, 'NY': 1.30, 'HI': 1.28, 'MA': 1.25, 'WA': 1.20,
  'NJ': 1.18, 'CT': 1.15, 'OR': 1.12, 'CO': 1.10, 'FL': 1.05,
  'TX': 1.00, 'NC': 0.95, 'TN': 0.90, 'AZ': 0.95, 'IN': 0.85,
  'MO': 0.82, 'AL': 0.80, 'MS': 0.75
};

// Trade-specific factors with national average wages (from specification)
export const TRADE_TYPES = [
  { name: 'Electrician', nationalAvg: 58000, highMarket: 72000, lowMarket: 46000 },
  { name: 'Plumber', nationalAvg: 56000, highMarket: 68000, lowMarket: 44000 },
  { name: 'HVAC Technician', nationalAvg: 52000, highMarket: 62000, lowMarket: 42000 },
  { name: 'Welder', nationalAvg: 47000, highMarket: 58000, lowMarket: 38000 },
  { name: 'Auto Mechanic', nationalAvg: 44000, highMarket: 54000, lowMarket: 36000 },
  { name: 'Carpenter', nationalAvg: 48000, highMarket: 58000, lowMarket: 38000 },
  { name: 'Heavy Equipment Operator', nationalAvg: 50000, highMarket: 62000, lowMarket: 40000 },
  { name: 'Roofer', nationalAvg: 42000, highMarket: 52000, lowMarket: 34000 },
  { name: 'Drywall Installer', nationalAvg: 40000, highMarket: 50000, lowMarket: 32000 },
  { name: 'Painter', nationalAvg: 38000, highMarket: 48000, lowMarket: 30000 },
  { name: 'Flooring Installer', nationalAvg: 41000, highMarket: 51000, lowMarket: 33000 },
  { name: 'Construction Laborer', nationalAvg: 36000, highMarket: 45000, lowMarket: 28000 },
  { name: 'Pipefitter', nationalAvg: 55000, highMarket: 68000, lowMarket: 44000 },
  { name: 'Sheet Metal Worker', nationalAvg: 50000, highMarket: 62000, lowMarket: 40000 },
  { name: 'Insulation Worker', nationalAvg: 43000, highMarket: 53000, lowMarket: 35000 },
  { name: 'Glazier', nationalAvg: 45000, highMarket: 55000, lowMarket: 36000 },
  { name: 'Other', nationalAvg: 45000, highMarket: 55000, lowMarket: 36000 }
];

// Legacy trade types for backward compatibility
export const LEGACY_TRADE_TYPES = [
  'Electrician',
  'Plumber',
  'HVAC Technician',
  'Carpenter',
  'Welder',
  'Heavy Equipment Operator',
  'Roofer',
  'Drywall Installer',
  'Painter',
  'Flooring Installer',
  'Construction Laborer',
  'Pipefitter',
  'Sheet Metal Worker',
  'Insulation Worker',
  'Glazier',
  'Other'
];

// Default values for calculations
export const CALCULATION_DEFAULTS = {
  weeksPerYear: 50, // Accounting for 2 weeks vacation/sick time
  housingBudgetPercentage: 0.30, // 30% for trade workers vs 28% standard
  emergencyFundMonths: 6,
  downPaymentPercentage: 0.20,
  mortgageInterestRate: 0.065, // 6.5% typical rate
  mortgageTermYears: 30,
  propertyTaxRate: 0.012, // 1.2% annual average
  homeInsuranceRate: 0.004, // 0.4% annual average (0.35% from spec)
  pmiRate: 0.005, // 0.5% annual if down payment < 20%
  // FHA specific
  fhaDownPayment: 0.035, // 3.5%
  fhaMipRate: 0.0085, // 0.85% for life of loan
  // Conventional
  conventionalDownPayment: 0.05, // 5%
  // VA
  vaDownPayment: 0.00, // 0%
  // Trade worker specific
  tradeWorkerRatio: 0.30, // 30% vs 28% standard
  conservativeRatio: 0.25 // 25% conservative
};

// Validation limits - Updated for specification
export const VALIDATION_LIMITS = {
  // Legacy limits
  hourlyRate: { min: 7.25, max: 200 }, // Federal minimum to high-skilled max
  regularHours: { min: 1, max: 80 },
  overtimeHours: { min: 0, max: 60 },
  overtimeMultiplier: { min: 1.0, max: 3.0 },
  weeksPerYear: { min: 26, max: 52 },
  // New limits for specification
  salary: { min: 25000, max: 150000 }, // Realistic for trades
  overtimeFactor: { min: 0, max: 0.40 }, // 0% - 40%
  regionalAdjustment: { min: 0.75, max: 1.35 } // Regional cost adjustment
};

// Overtime factor options for dropdown (0-40%)
export const OVERTIME_FACTOR_OPTIONS = [
  { value: 0.00, label: '0% (No Overtime)' },
  { value: 0.05, label: '5%' },
  { value: 0.10, label: '10%' },
  { value: 0.15, label: '15% (Typical)' },
  { value: 0.20, label: '20%' },
  { value: 0.25, label: '25% (High)' },
  { value: 0.30, label: '30%' },
  { value: 0.35, label: '35%' },
  { value: 0.40, label: '40% (Maximum)' }
];

// Common overtime multipliers
export const OVERTIME_MULTIPLIERS = [
  { value: 1.0, label: '1.0x (Regular Time)' },
  { value: 1.5, label: '1.5x (Time and a Half)' },
  { value: 2.0, label: '2.0x (Double Time)' }
];

// Down payment scenarios for calculations
export const DOWN_PAYMENT_SCENARIOS = [
  { type: 'FHA', percentage: 0.035, label: 'FHA (3.5%)' },
  { type: 'Conventional', percentage: 0.05, label: 'Conventional (5%)' },
  { type: 'VA', percentage: 0.00, label: 'VA (0%)' },
  { type: 'Cash', percentage: 1.00, label: 'Cash Purchase' }
];

// Market data - comprehensive dataset including major markets, Texas cities, and all 50 state capitals
export const MARKET_DATA: MarketData[] = [
  {
    cityName: 'Phoenix',
    state: 'AZ',
    medianHomePrice: 425000,
    starterHomePrice: 285000,
    propertyTaxRate: 0.0066, // 0.66%
    stateIncomeTaxRate: 0.025, // 2.5%
    tradeSalaryPremium: 0.08, // 8% premium
    costOfLivingIndex: 1.05
  },
  {
    cityName: 'Nashville',
    state: 'TN',
    medianHomePrice: 385000,
    starterHomePrice: 265000,
    propertyTaxRate: 0.0071, // 0.71%
    stateIncomeTaxRate: 0.00, // No state income tax
    tradeSalaryPremium: 0.12, // 12% premium
    costOfLivingIndex: 1.02
  },
  {
    cityName: 'Tampa',
    state: 'FL',
    medianHomePrice: 365000,
    starterHomePrice: 245000,
    propertyTaxRate: 0.0083, // 0.83%
    stateIncomeTaxRate: 0.00, // No state income tax
    tradeSalaryPremium: 0.06, // 6% premium
    costOfLivingIndex: 0.98
  },
  {
    cityName: 'Charlotte',
    state: 'NC',
    medianHomePrice: 355000,
    starterHomePrice: 240000,
    propertyTaxRate: 0.0084, // 0.84%
    stateIncomeTaxRate: 0.055, // 5.5%
    tradeSalaryPremium: 0.10, // 10% premium
    costOfLivingIndex: 0.96
  },
  {
    cityName: 'Indianapolis',
    state: 'IN',
    medianHomePrice: 245000,
    starterHomePrice: 165000,
    propertyTaxRate: 0.0083, // 0.83%
    stateIncomeTaxRate: 0.032, // 3.2%
    tradeSalaryPremium: 0.05, // 5% premium
    costOfLivingIndex: 0.89
  },
  {
    cityName: 'Kansas City',
    state: 'MO',
    medianHomePrice: 265000,
    starterHomePrice: 185000,
    propertyTaxRate: 0.0097, // 0.97%
    stateIncomeTaxRate: 0.054, // 5.4%
    tradeSalaryPremium: 0.07, // 7% premium
    costOfLivingIndex: 0.87
  },
  {
    cityName: 'Memphis',
    state: 'TN',
    medianHomePrice: 185000,
    starterHomePrice: 125000,
    propertyTaxRate: 0.0125, // 1.25%
    stateIncomeTaxRate: 0.00, // No state income tax
    tradeSalaryPremium: 0.03, // 3% premium
    costOfLivingIndex: 0.82
  },
  {
    cityName: 'Birmingham',
    state: 'AL',
    medianHomePrice: 165000,
    starterHomePrice: 115000,
    propertyTaxRate: 0.0042, // 0.42%
    stateIncomeTaxRate: 0.05, // 5%
    tradeSalaryPremium: 0.02, // 2% premium
    costOfLivingIndex: 0.85
  },

  // TEXAS CITIES EXPANSION
  {
    cityName: 'Longview',
    state: 'TX',
    medianHomePrice: 225000,
    starterHomePrice: 180000,
    propertyTaxRate: 0.0180,
    stateIncomeTaxRate: 0.00, // No state income tax
    tradeSalaryPremium: -0.21, // 21% below national average
    costOfLivingIndex: 0.846
  },
  {
    cityName: 'Tyler',
    state: 'TX',
    medianHomePrice: 258000,
    starterHomePrice: 206000,
    propertyTaxRate: 0.0175,
    stateIncomeTaxRate: 0.00, // No state income tax
    tradeSalaryPremium: -0.18, // 18% below national average
    costOfLivingIndex: 0.852
  },
  {
    cityName: 'Dallas',
    state: 'TX',
    medianHomePrice: 315000,
    starterHomePrice: 252000,
    propertyTaxRate: 0.0174,
    stateIncomeTaxRate: 0.00, // No state income tax
    tradeSalaryPremium: 0.01, // 1% above national average
    costOfLivingIndex: 1.002
  },
  {
    cityName: 'Austin',
    state: 'TX',
    medianHomePrice: 513000,
    starterHomePrice: 410000,
    propertyTaxRate: 0.0161,
    stateIncomeTaxRate: 0.00, // No state income tax
    tradeSalaryPremium: 0.08, // 8% premium
    costOfLivingIndex: 1.291
  },
  {
    cityName: 'San Antonio',
    state: 'TX',
    medianHomePrice: 257000,
    starterHomePrice: 206000,
    propertyTaxRate: 0.0203,
    stateIncomeTaxRate: 0.00, // No state income tax
    tradeSalaryPremium: -0.13, // 13% below national average
    costOfLivingIndex: 0.913
  },

  // US STATE CAPITALS
  // Northeast Region
  {
    cityName: 'Albany',
    state: 'NY', 
    medianHomePrice: 284310,
    starterHomePrice: 227448,
    propertyTaxRate: 0.0200,
    stateIncomeTaxRate: 0.0625,
    tradeSalaryPremium: 0.08,
    costOfLivingIndex: 0.993
  },
  {
    cityName: 'Boston',
    state: 'MA', 
    medianHomePrice: 719353,
    starterHomePrice: 575482,
    propertyTaxRate: 0.0120,
    stateIncomeTaxRate: 0.0500,
    tradeSalaryPremium: 0.15,
    costOfLivingIndex: 1.20
  },
  {
    cityName: 'Concord',
    state: 'NH', 
    medianHomePrice: 381448,
    starterHomePrice: 305158,
    propertyTaxRate: 0.0180,
    stateIncomeTaxRate: 0.0000, // No state income tax
    tradeSalaryPremium: 0.05,
    costOfLivingIndex: 1.06
  },
  {
    cityName: 'Hartford',
    state: 'CT', 
    medianHomePrice: 350000,
    starterHomePrice: 280000,
    propertyTaxRate: 0.0205,
    stateIncomeTaxRate: 0.0500,
    tradeSalaryPremium: 0.10,
    costOfLivingIndex: 1.08
  },
  {
    cityName: 'Providence',
    state: 'RI', 
    medianHomePrice: 500000,
    starterHomePrice: 400000,
    propertyTaxRate: 0.0163,
    stateIncomeTaxRate: 0.0475,
    tradeSalaryPremium: 0.08,
    costOfLivingIndex: 1.12
  },
  {
    cityName: 'Montpelier',
    state: 'VT', 
    medianHomePrice: 413824,
    starterHomePrice: 331059,
    propertyTaxRate: 0.0176,
    stateIncomeTaxRate: 0.0660,
    tradeSalaryPremium: 0.06,
    costOfLivingIndex: 1.13
  },
  {
    cityName: 'Annapolis',
    state: 'MD', 
    medianHomePrice: 571768,
    starterHomePrice: 457414,
    propertyTaxRate: 0.0108,
    stateIncomeTaxRate: 0.0475,
    tradeSalaryPremium: 0.10,
    costOfLivingIndex: 1.147
  },
  {
    cityName: 'Trenton',
    state: 'NJ', 
    medianHomePrice: 280151,
    starterHomePrice: 224121,
    propertyTaxRate: 0.0223,
    stateIncomeTaxRate: 0.0637,
    tradeSalaryPremium: 0.12,
    costOfLivingIndex: 1.15
  },
  {
    cityName: 'Harrisburg',
    state: 'PA', 
    medianHomePrice: 234569,
    starterHomePrice: 187655,
    propertyTaxRate: 0.0141,
    stateIncomeTaxRate: 0.0307,
    tradeSalaryPremium: 0.05,
    costOfLivingIndex: 0.94
  },
  {
    cityName: 'Dover',
    state: 'DE', 
    medianHomePrice: 301000,
    starterHomePrice: 240800,
    propertyTaxRate: 0.0057,
    stateIncomeTaxRate: 0.0520,
    tradeSalaryPremium: 0.06,
    costOfLivingIndex: 1.02
  },
  {
    cityName: 'Augusta',
    state: 'ME', 
    medianHomePrice: 268000,
    starterHomePrice: 214400,
    propertyTaxRate: 0.0125,
    stateIncomeTaxRate: 0.0715,
    tradeSalaryPremium: 0.04,
    costOfLivingIndex: 0.886
  },

  // Southeast Region
  {
    cityName: 'Atlanta',
    state: 'GA', 
    medianHomePrice: 379911,
    starterHomePrice: 303929,
    propertyTaxRate: 0.0091,
    stateIncomeTaxRate: 0.0539,
    tradeSalaryPremium: 0.03,
    costOfLivingIndex: 1.133
  },
  {
    cityName: 'Raleigh',
    state: 'NC', 
    medianHomePrice: 431344,
    starterHomePrice: 345075,
    propertyTaxRate: 0.0084,
    stateIncomeTaxRate: 0.0425,
    tradeSalaryPremium: 0.04,
    costOfLivingIndex: 1.08
  },
  {
    cityName: 'Richmond',
    state: 'VA', 
    medianHomePrice: 391035,
    starterHomePrice: 312828,
    propertyTaxRate: 0.0087,
    stateIncomeTaxRate: 0.0500,
    tradeSalaryPremium: 0.05,
    costOfLivingIndex: 1.03
  },
  {
    cityName: 'Charleston',
    state: 'WV', 
    medianHomePrice: 200000,
    starterHomePrice: 160000,
    propertyTaxRate: 0.0095,
    stateIncomeTaxRate: 0.0450,
    tradeSalaryPremium: -0.15,
    costOfLivingIndex: 0.88
  },
  {
    cityName: 'Columbia',
    state: 'SC', 
    medianHomePrice: 346350,
    starterHomePrice: 277080,
    propertyTaxRate: 0.0084,
    stateIncomeTaxRate: 0.0600,
    tradeSalaryPremium: -0.05,
    costOfLivingIndex: 0.96
  },
  {
    cityName: 'Tallahassee',
    state: 'FL', 
    medianHomePrice: 281143,
    starterHomePrice: 224914,
    propertyTaxRate: 0.0097,
    stateIncomeTaxRate: 0.0000, // No state income tax
    tradeSalaryPremium: -0.08,
    costOfLivingIndex: 0.94
  },
  {
    cityName: 'Montgomery',
    state: 'AL', 
    medianHomePrice: 180000,
    starterHomePrice: 144000,
    propertyTaxRate: 0.0041,
    stateIncomeTaxRate: 0.0400,
    tradeSalaryPremium: -0.18,
    costOfLivingIndex: 0.86
  },
  {
    cityName: 'Jackson',
    state: 'MS', 
    medianHomePrice: 285407,
    starterHomePrice: 228326,
    propertyTaxRate: 0.0081,
    stateIncomeTaxRate: 0.0440,
    tradeSalaryPremium: -0.20,
    costOfLivingIndex: 0.833
  },
  {
    cityName: 'Little Rock',
    state: 'AR', 
    medianHomePrice: 197594,
    starterHomePrice: 158075,
    propertyTaxRate: 0.0062,
    stateIncomeTaxRate: 0.0500,
    tradeSalaryPremium: -0.15,
    costOfLivingIndex: 0.87
  },
  {
    cityName: 'Baton Rouge',
    state: 'LA', 
    medianHomePrice: 210000,
    starterHomePrice: 168000,
    propertyTaxRate: 0.0055,
    stateIncomeTaxRate: 0.0300,
    tradeSalaryPremium: -0.12,
    costOfLivingIndex: 0.89
  },
  {
    cityName: 'Frankfort',
    state: 'KY', 
    medianHomePrice: 205531,
    starterHomePrice: 164425,
    propertyTaxRate: 0.0085,
    stateIncomeTaxRate: 0.0400,
    tradeSalaryPremium: -0.10,
    costOfLivingIndex: 0.91
  },

  // Midwest Region
  {
    cityName: 'Columbus',
    state: 'OH', 
    medianHomePrice: 195000,
    starterHomePrice: 156000,
    propertyTaxRate: 0.0157,
    stateIncomeTaxRate: 0.0370,
    tradeSalaryPremium: -0.05,
    costOfLivingIndex: 0.93
  },
  {
    cityName: 'Lansing',
    state: 'MI', 
    medianHomePrice: 135900,
    starterHomePrice: 108720,
    propertyTaxRate: 0.0162,
    stateIncomeTaxRate: 0.0405,
    tradeSalaryPremium: -0.08,
    costOfLivingIndex: 0.89
  },
  {
    cityName: 'Madison',
    state: 'WI', 
    medianHomePrice: 350000,
    starterHomePrice: 280000,
    propertyTaxRate: 0.0195,
    stateIncomeTaxRate: 0.0535,
    tradeSalaryPremium: 0.02,
    costOfLivingIndex: 1.01
  },
  {
    cityName: 'Springfield',
    state: 'IL', 
    medianHomePrice: 160000,
    starterHomePrice: 128000,
    propertyTaxRate: 0.0231,
    stateIncomeTaxRate: 0.0495,
    tradeSalaryPremium: 0.05,
    costOfLivingIndex: 0.91
  },
  {
    cityName: 'Des Moines',
    state: 'IA', 
    medianHomePrice: 220000,
    starterHomePrice: 176000,
    propertyTaxRate: 0.0159,
    stateIncomeTaxRate: 0.0380,
    tradeSalaryPremium: -0.03,
    costOfLivingIndex: 0.90
  },
  {
    cityName: 'Topeka',
    state: 'KS', 
    medianHomePrice: 197713,
    starterHomePrice: 158170,
    propertyTaxRate: 0.0149,
    stateIncomeTaxRate: 0.0465,
    tradeSalaryPremium: -0.08,
    costOfLivingIndex: 0.88
  },
  {
    cityName: 'Lincoln',
    state: 'NE', 
    medianHomePrice: 295000,
    starterHomePrice: 236000,
    propertyTaxRate: 0.0169,
    stateIncomeTaxRate: 0.0584,
    tradeSalaryPremium: -0.05,
    costOfLivingIndex: 0.92
  },
  {
    cityName: 'Jefferson City',
    state: 'MO', 
    medianHomePrice: 233847,
    starterHomePrice: 187078,
    propertyTaxRate: 0.0097,
    stateIncomeTaxRate: 0.0470,
    tradeSalaryPremium: -0.08,
    costOfLivingIndex: 0.89
  },
  {
    cityName: 'Bismarck',
    state: 'ND', 
    medianHomePrice: 341000,
    starterHomePrice: 272800,
    propertyTaxRate: 0.0098,
    stateIncomeTaxRate: 0.0250,
    tradeSalaryPremium: 0.15,
    costOfLivingIndex: 1.05
  },
  {
    cityName: 'Pierre',
    state: 'SD', 
    medianHomePrice: 276189,
    starterHomePrice: 221351,
    propertyTaxRate: 0.0128,
    stateIncomeTaxRate: 0.0000, // No state income tax
    tradeSalaryPremium: 0.08,
    costOfLivingIndex: 0.95
  },

  // Southwest Region
  {
    cityName: 'Santa Fe',
    state: 'NM', 
    medianHomePrice: 570886,
    starterHomePrice: 456709,
    propertyTaxRate: 0.0087,
    stateIncomeTaxRate: 0.0475,
    tradeSalaryPremium: -0.05,
    costOfLivingIndex: 1.08
  },
  {
    cityName: 'Oklahoma City',
    state: 'OK', 
    medianHomePrice: 199133,
    starterHomePrice: 159306,
    propertyTaxRate: 0.0090,
    stateIncomeTaxRate: 0.0400,
    tradeSalaryPremium: -0.10,
    costOfLivingIndex: 0.87
  },

  // West Region
  {
    cityName: 'Denver',
    state: 'CO', 
    medianHomePrice: 609925,
    starterHomePrice: 487940,
    propertyTaxRate: 0.0060,
    stateIncomeTaxRate: 0.0440,
    tradeSalaryPremium: 0.08,
    costOfLivingIndex: 1.15
  },
  {
    cityName: 'Boise',
    state: 'ID', 
    medianHomePrice: 502667,
    starterHomePrice: 402134,
    propertyTaxRate: 0.0077,
    stateIncomeTaxRate: 0.0580,
    tradeSalaryPremium: 0.05,
    costOfLivingIndex: 1.12
  },
  {
    cityName: 'Helena',
    state: 'MT', 
    medianHomePrice: 445567,
    starterHomePrice: 356454,
    propertyTaxRate: 0.0083,
    stateIncomeTaxRate: 0.0550,
    tradeSalaryPremium: 0.10,
    costOfLivingIndex: 1.08
  },
  {
    cityName: 'Cheyenne',
    state: 'WY', 
    medianHomePrice: 362103,
    starterHomePrice: 289682,
    propertyTaxRate: 0.0062,
    stateIncomeTaxRate: 0.0000, // No state income tax
    tradeSalaryPremium: 0.12,
    costOfLivingIndex: 0.96
  },
  {
    cityName: 'Carson City',
    state: 'NV', 
    medianHomePrice: 449950,
    starterHomePrice: 359960,
    propertyTaxRate: 0.0084,
    stateIncomeTaxRate: 0.0000, // No state income tax
    tradeSalaryPremium: 0.08,
    costOfLivingIndex: 1.05
  },
  {
    cityName: 'Olympia',
    state: 'WA', 
    medianHomePrice: 513591,
    starterHomePrice: 410873,
    propertyTaxRate: 0.0092,
    stateIncomeTaxRate: 0.0000, // No state income tax
    tradeSalaryPremium: 0.15,
    costOfLivingIndex: 1.18
  },
  {
    cityName: 'Salem',
    state: 'OR', 
    medianHomePrice: 427992,
    starterHomePrice: 342394,
    propertyTaxRate: 0.0103,
    stateIncomeTaxRate: 0.0750,
    tradeSalaryPremium: 0.18,
    costOfLivingIndex: 1.15
  },
  {
    cityName: 'Sacramento',
    state: 'CA', 
    medianHomePrice: 465589,
    starterHomePrice: 372471,
    propertyTaxRate: 0.0075,
    stateIncomeTaxRate: 0.0800,
    tradeSalaryPremium: 0.12,
    costOfLivingIndex: 1.422
  },
  {
    cityName: 'Juneau',
    state: 'AK', 
    medianHomePrice: 472325,
    starterHomePrice: 377860,
    propertyTaxRate: 0.0113,
    stateIncomeTaxRate: 0.0000, // No state income tax
    tradeSalaryPremium: 0.25,
    costOfLivingIndex: 1.28
  },
  {
    cityName: 'Honolulu',
    state: 'HI', 
    medianHomePrice: 562500,
    starterHomePrice: 450000,
    propertyTaxRate: 0.0030,
    stateIncomeTaxRate: 0.0750,
    tradeSalaryPremium: 0.20,
    costOfLivingIndex: 1.933
  }
];

// Sample regional data (in a real app, this might come from an API)
export const SAMPLE_REGIONAL_DATA: Record<string, RegionalFactors> = {
  'CA-urban': {
    state: 'CA',
    cityType: 'urban',
    costOfLivingIndex: 1.4,
    averagePropertyTax: 0.007,
    averageInsurance: 0.005
  },
  'TX-suburban': {
    state: 'TX',
    cityType: 'suburban',
    costOfLivingIndex: 1.0,
    averagePropertyTax: 0.018,
    averageInsurance: 0.003
  },
  'FL-rural': {
    state: 'FL',
    cityType: 'rural',
    costOfLivingIndex: 0.9,
    averagePropertyTax: 0.008,
    averageInsurance: 0.004
  }
};